import React, {useState} from 'react';
import {Button, Container, Icon} from "atomize";
import theme from "./../../../Theme/Theme";
import GridIcon from './../GridIcon';
import styled from 'styled-components';
import GraphIcon from './../GraphIcon';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  button {
    margin: 0;
  }
  button:nth-of-type(1) {
    border-radius: 4px 0 0 4px;
  }
  button:nth-of-type(2) {
    border-radius: 0 4px 4px 0;
  }
  
  svg {
    transition: fill .15s ease-in-out;
    g {
      transition: fill .15s ease-in-out;
    }
    path {
      transition: fill .15s ease-in-out;
    }
  }
`;

function Toggle(props) {
  const [active, setActive] = useState( props.value ? props.value : 0);
  return (
    <Wrapper>
      <Button
        h="2.5rem"
        bg={ active === 0? theme.colors.primary : theme.colors.disabled }
        hoverBg={null}
        onClick={()=> {
          setActive(0);
          props.action(0)
        }}
      >
        <GridIcon
          size={'20px'}
          color={active === 0? 'white' : theme.colors.grayDark}
        />
      </Button>
      <Button
        h="2.5rem"
        bg={ active === 1? theme.colors.primary : theme.colors.disabled }
        hoverBg={null}
        onClick={()=> {
          setActive(1);
          props.action(1)
        }}
      >
        { props.type === 'graph' ?
          <GraphIcon
            size="20px"
            color={active === 1? 'white' : theme.colors.grayDark }
          />
          :
          <Icon
            name="Location"
            size="20px"
            color={active === 1? 'white' : theme.colors.grayDark }
          />
        }
      </Button>
    </Wrapper>
  )
}

export default Toggle
